module.exports = __webpack_public_path__ + "a616070d9c34b714b9ad248e37098b41.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/map.png
// module id = dVPB
// module chunks = 0